import Vue from 'vue'
import VueSecureHTML from 'vue-html-secure'

Vue.use(VueSecureHTML)
Vue.prototype.$removeHTML = VueSecureHTML.removeHTML
Vue.prototype.$escapeHTML = VueSecureHTML.escapeHTML
Vue.prototype.$safeHTML = VueSecureHTML.safeHTML
